<template>
  <div>
    <Head :title="__('Log In')" />

    <form
      @submit.prevent="attempt"
      class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
    >
      <h2 class="text-2xl text-center font-normal mb-6 text-90">
        Bem-vindo!
      </h2>

      <p v-if="currentTenant === 'pmc'" class="mb-4 font-bold" style="color: #00b69c;">Acesse com os dados do portal do servidor</p>

      <div class="mb-6">
        <label class="block mb-2" for="cpf">CPF</label>
        <input
          v-model="form.cpf"
          class="form-control form-input form-input-bordered w-full"
          :class="{ 'form-input-border-error': form.errors.has('cpf') }"
          id="cpf"
          type="cpf"
          name="cpf"
          autofocus=""
          required
        />

        <HelpText class="mt-2 text-red-500" v-if="form.errors.has('cpf')">
          {{ form.errors.first('cpf') }}
        </HelpText>
      </div>

      <div class="mb-6">
        <label class="block mb-2" for="password">{{ __('Password') }}</label>
        <input
          v-model="form.password"
          class="form-control form-input form-input-bordered w-full"
          :class="{ 'form-input-border-error': form.errors.has('password') }"
          id="password"
          type="password"
          name="password"
          required
        />

        <HelpText class="mt-2 text-red-500" v-if="form.errors.has('password')">
          {{ form.errors.first('password') }}
        </HelpText>
      </div>
      <div class="flex mb-6">
        <CheckboxWithLabel
          :checked="form.remember"
          @input="() => (form.remember = !form.remember)"
        >
          {{ __('Remember me') }}
        </CheckboxWithLabel>

        <div class="ml-auto">
          <a
            :href="forgotPasswordPath"
            class="text-gray-500 font-bold no-underline"
            v-text="__('Forgot your password?')"
            v-tooltip="currentTenant === 'pmc' ? 'Você será redirecionado ao portal do servidor' : 'Mudar senha'"
          />
        </div>

        <div class="ml-auto">
          <a
            :href="firstAccessPath"
            class="text-gray-500 font-bold no-underline"
            v-tooltip="currentTenant === 'pmc' ? 'Você será redirecionado ao portal do servidor' : 'Primeiro acesso'">
          Primeiro acesso?</a>
        </div>
      </div>

      <DefaultButton class="w-full flex justify-center" type="submit">
        <span>
          {{ __('Log In') }}
        </span>
      </DefaultButton>
    </form>
      <div v-if="loading" class="fixed inset-0 flex items-center justify-center z-50">
          <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
  </div>
</template>

<script>
import Auth from '@/layouts/Auth'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginPage',
  props:["haveAccount"],

  layout: Auth,

  data: () => ({
    form: Nova.form({
      cpf: '',
      password: '',
      remember: false,
    }),
    loading: false,
  }),
  
  methods: {
    async attempt() {
      try {
              this.loading = true; // Show the loading indicator
              const { redirect } = await this.form.post(Nova.url('/login'))
              let path = '/'

              if (redirect !== undefined && redirect !== null) {
                  path = { url: redirect, remote: true }
              }

              Nova.visit(path)
          } finally {
              this.loading = false; // Hide the loading indicator when the request is complete
          }
      }
  },

  computed: {
    ...mapGetters(['getCurrentTenant']),
    currentTenant(){
      return this.getCurrentTenant
    },
    supportsPasswordReset() {
      return Nova.config('withPasswordReset')
    },

    forgotPasswordPath() {
      if (Nova.config('withExternalRoute')) {
        return "http://sistemas.cuiaba.mt.gov.br/portaldoservidor/portal/esqueciminhasenha.html"
      }

      return Nova.config('forgotPasswordPath')
    },

    firstAccessPath() {
      if (Nova.config('withExternalRoute')) {
        return "http://sistemas.cuiaba.mt.gov.br/portaldoservidor/portal/login.html"
      }

      return Nova.config('firstAccess')
    },
  },
}
</script>